import { useQuery } from 'react-query';
import getInvestAccounts from '../services/API/getInvestAccounts';
import { getReactQueryKeys } from 'utils/getReactQueryKeys';

export const useInvestAccounts = ({ pagination, filter, sort }) => {
  return useQuery(
    ['investAccounts', ...getReactQueryKeys({ pagination, filter, sort })],
    async () => {
      const res = await getInvestAccounts({ pagination, filter, sort });
      return res.data;

      // return new Promise((resolve) => {
      //   setTimeout(() => {
      //     resolve(mockData);
      //   }, 1000);
      // });
    },
    { keepPreviousData: true },
  );
};

// const mockData = {
//   totalPages: 2,
//   totalElements: 18,
//   size: 10,
//   number: 0,
//   content: [
//     {
//       brokerName: 'ОБЩЕСТВО С ОГРАНИЧЕННОЙ ОТВЕТСТВЕННОСТЬЮ "АЛЬФА-КАПИТАЛ"',
//       brokerInn: '7728142469',
//       contractNumber: '№ 61143/ДУ-ФЛ-ИИС-2017',
//       contractDateBegin: '2017-12-23',
//       iisOpenDate: '2017-12-24',
//       iisEndDate: '',
//       iisState: 'OPEN',
//     },
//     {
//       brokerName: 'ОБЩЕСТВО С ОГРАНИЧЕННОЙ ОТВЕТСТВЕННОСТЬЮ "АЛЬФА-КАПИТАЛ"',
//       brokerInn: '7728142469',
//       contractNumber: '№ 61143/ДУ-ФЛ-ИИС-2017',
//       contractDateBegin: '2017-12-23',
//       iisOpenDate: '2017-12-24',
//       iisEndDate: '2018-04-21',
//       iisState: 'CLOSE',
//     },
//     {
//       brokerName: 'ОБЩЕСТВО С ОГРАНИЧЕННОЙ ОТВЕТСТВЕННОСТЬЮ "АЛЬФА-КАПИТАЛ"',
//       brokerInn: '7728142469',
//       contractNumber: '№ 61143/ДУ-ФЛ-ИИС-2017',
//       contractDateBegin: '2017-12-23',
//       iisOpenDate: '2017-08-24',
//       iisEndDate: null,
//       iisState: 'CLOSE_WITH_TRANSFER',
//     },
//     {
//       brokerName: 'ОБЩЕСТВО С ОГРАНИЧЕННОЙ ОТВЕТСТВЕННОСТЬЮ "АЛЬФА-КАПИТАЛ"',
//       brokerInn: '7728142469',
//       contractNumber: '№ 61143/ДУ-ФЛ-ИИС-2017',
//       contractDateBegin: '2017-12-23',
//       iisOpenDate: '2017-12-24',
//       iisEndDate: '',
//       iisState: 'OPEN',
//     },
//   ],
// };
